module.exports = __webpack_public_path__ + "FisicoDigital.41acf1d28597f37cccfac0c529339982.png";